import {
    SET_CREATE_NEW_CODE_LIST,
    SET_CREATE_NEW_CODE_SAVE
} from "./AcquisitionCodeType";

const initialState = {
    createNewCodeList: [],
    createNewCodeSave: {}
}

const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_CREATE_NEW_CODE_LIST:
            return {
                ...state,
                createNewCodeList: action.createNewCodeList,
            };
            case SET_CREATE_NEW_CODE_SAVE:
            return {
                ...state,
                createNewCodeSave: action.createNewCodeSave,
            };
        default:
            return state;
    }
};

export default reducer;
